<div class="col-md-12 mb-30" [hidden]="Data_Seleted_Record.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات فرم های فرآیند ساز</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Form">
              <td>{{DataList_Form.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <button (click)="Set_Data_Seleted_Record(item)" type="button" class="btn btn-danger">
                  گردش کار
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<div class="col-md-12 mb-30" [hidden]="Data_Seleted_Record.id==0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات گردش کار فرم '{{Data_Seleted_Record.title}}'</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="OnGet_Person_Action(templateFormHistory)" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن گردش کار </button>
          <button  *ngIf="!Procssing" (click)="Reset_Data_Seleted_Record()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th>کاربر</th>
              <th>زمان</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_FormDetail| paginate
            : {
                id: 'DataList_FeildTable',
                itemsPerPage: 50,
                currentPage: page,
                totalItems: DataList_FormDetail.length
              }
              ">
              <td>{{DataList_FormDetail.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>



<ng-template #templateFormHistory>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست 'گردش کار' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_FormHistory.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">عنوان گردش کار</label>
          <input [(ngModel)]="Filter_WorkflowTitle" (keyup)="Change_Filter()" name="Filter_WorkflowTitle" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>گردش کار</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_FormHistory
            |filter:Filter_WorkflowTitle:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: FormHistorypage,
                        totalItems: (DataList_FormHistory
                        |filter:Filter_WorkflowTitle:'title'
                        ).length
                      }
            ">
              <td>{{DataList_FormHistory.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_FormHistory_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_FormHistory" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_FormHistory" type="button" (click)="ReadData_FormHistory()"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_FormHistory.hide()">بستن</button>
  </div>
</ng-template>
